module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (161).ad058724.jpg";